export default "__VITE_ASSET__CjKfgj25__"